module.exports = {
  presentation: {
    noData: "No Data",
    noScriptToPlay: "This presentation has no script to play.",
    loading: "loading...",
    end: {
      title: "Contact us",
      nameRequired: "name is required",
      emailRequired: "email is required",
      emailNoValid: "email is not valid",
      phoneNoValid: "mobile phone is not valid",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        message: "Message",
      },
      contactUs: "Contact us",
      email: "Contact email",
      phone: "Contact phone",
      noData:'There is no recommended video yet',
      recommendedVideo: "Recommended video",
      ThankSupport: "Thank you for your support",
      send:"Send",
      reload:"Reload",
      share:"Share",
      copyNotify:'The sharing path has been copied to the pasteboard.',
      btnText:'Call-to-action',
      impression:'Impression',
      playCount: 'Play volume',
      createdAt: 'Time of creation',
      errorLink: 'Sorry, the link is invalid.'
    }
  }
};